<template lang="pug">
  v-footer(
    color="primary"
    dark
    height="auto"
  )
    //- Container pads our columns here
    v-container
      v-layout(
        justify-center
        row
        wrap
      )
        v-flex(
          primary
          xs4
        )
          .headline About Us
          .body-1
            | GetMyVan Ltd
            br
            | 35 Guildersfield Road
            br
            | London, United Kingdom SW16 5LS
            br
            a#email.white--text(href="mailto:support@getmyvan.co.uk")
              strong support@getmyvan.co.uk
        v-flex(
          primary
          xs4
        )
          .headline Legal
          .body-1
            v-btn(
              flat
              small
              @click="pageTransfer('pages/terms-and-conditions')"
            ) Terms and Conditions
            br
            v-btn(
              flat
              small
              @click="pageTransfer('pages/privacy-policy')"
            ) Privacy and Cookie Policy
        v-flex(
          primary
          xs4
        )
          .headline Social
          .body-1 Coming Soon...
</template>

<script>
export default {
  methods: {
    pageTransfer(to) {
      this.$router.push(`/${to}`);
    },
  },
};
</script>

<style lang="stylus" scoped>
#email
  text-decoration none
</style>
